<script setup>
import { reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import validations from './helpers/validations';
import FormInput from 'v3/components/Form/Input.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  onSubmit: { type: Function, default: () => {} },
  submitInProgress: { type: Boolean, default: false },
  formData: { type: Object, default: () => ({}) },
  submitButtonText: { type: String, default: '' },
});
const {
  description = '',
  name: title = '',
  allow_auto_assign: allowAutoAssign = true,
} = props.formData || {};
const state = reactive({ description, title, allowAutoAssign });
const v$ = useVuelidate(validations, state);

function handleSubmit() {
  if (props.submitInProgress) return;
  v$.value.$touch();
  if (v$.value.$invalid) return;
  props.onSubmit({
    description: state.description,
    name: state.title,
    allow_auto_assign: state.allowAutoAssign,
  });
}
</script>

<template>
  <div class="flex-shrink-0 w-full">
    <form class="mx-0 grid gap-4" @submit.prevent="handleSubmit">
      <FormInput
        v-model="state.title"
        id="team-name"
        name="team-name"
        :disabled="submitInProgress"
        spacing="compact"
        class="!h-11 !text-base"
        :label="$t('TEAMS_SETTINGS.FORM.NAME.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.NAME.PLACEHOLDER')"
        :has-error="v$.title.$error"
        :error-message="v$.title.$error ? v$.title.$errors[0].$message : ''"
        @blur="v$.title.$touch"
      />
      <FormInput
        v-model="state.description"
        id="team-description"
        name="team-description"
        :disabled="submitInProgress"
        spacing="compact"
        class="!h-11 !text-base"
        :label="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.LABEL')"
        :placeholder="$t('TEAMS_SETTINGS.FORM.DESCRIPTION.PLACEHOLDER')"
        :has-error="v$.description.$error"
        :error-message="
          v$.description.$error ? v$.description.$errors[0].$message : ''
        "
        @blur="v$.description.$touch"
      />
      <label class="w-full min-h-11 flex items-center gap-3 cursor-pointer">
        <input v-model="state.allowAutoAssign" :disabled="submitInProgress" type="checkbox" :value="true" />
        <span class="text-sm text-n-slate-12">
          {{ $t('TEAMS_SETTINGS.FORM.AUTO_ASSIGN.LABEL') }}
        </span>
      </label>
      <!-- Editar time junta os participantes nesta mesma pagina. -->
      <slot />
      <div class="flex flex-row justify-end gap-2 py-2 px-0 w-full">
        <div class="w-full">
          <NextButton
            type="submit"
            class="min-h-11"
            :label="submitButtonText"
            :disabled="v$.title.$invalid || submitInProgress"
            :is-loading="submitInProgress"
          />
        </div>
      </div>
    </form>
  </div>
</template>
